import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({
      id: 'settings.users.view.changePasswordModal.header.title',
    }),
    subtitle: translate({
      id: 'settings.users.view.changePasswordModal.header.subtitle',
    }),
  }))

  return api
}
